import { computed, makeObservable, observable } from 'mobx';
import * as appBrand from '../config/app-brand-config.json';

export class CommonStore {

  constructor() {
    makeObservable(this);
  }

  @observable appName = '';
  @observable appVersion = '';
  @observable brand = {};
  @observable spaceLogoUrl = '';
  @observable callDisclaimer;
  @observable disclaimer = {
    content: '',
    showBlock: appBrand.disclaimer.showBlock,
  };
  @observable organizations = [];
  @observable termsOfUse = {
    content: '',
    showBlock: true,
  };
  @observable user;

  @computed get termsOfUseInfo() {
    const termsOfUseInfo = {};
    termsOfUseInfo.content = termsOfUseInfo.content;
    termsOfUseInfo.complete = false;
    return termsOfUseInfo;
  }

  @computed get userAndBrand() {
    const userAndBrand = {};
    userAndBrand.brand = this.brand;
    userAndBrand.user = this.user;
    return userAndBrand;
  }
}

const commonStore = new CommonStore();
window.store = commonStore;
export default commonStore;
